import React, { useEffect } from "react";
import { TextArea } from "semantic-ui-react";
import { useSemanticUiTextAreaRef } from "utilities/hookutils";
import { replaceNewLineWithBr } from "utilities/reactUtils";

export interface OptionalTextAreaInputProps {
  value: string
  onChange: (newTitle: string) => void
  maxLength: number
  onBlur?: () => void
  onCtrlEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  rows?: number
  style?: React.CSSProperties
}

const OptionalTextAreaInput = (props: OptionalTextAreaInputProps) => {
  const textAreaRef = useSemanticUiTextAreaRef();

  useEffect(() => {
    if (props.focusOnMount) {
      textAreaRef.ref.current.focus();
      textAreaRef.ref.current.selectionStart = textAreaRef.ref.current.selectionEnd - textAreaRef.ref.current.value.length;
      textAreaRef.ref.current.scrollTop = textAreaRef.ref.current.scrollHeight;
    }
  }, []);

  const onChange = (_, { value }) => {
    props.onChange(value);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      props.onEsc?.();
    } else if (e.ctrlKey && e.key === "Enter") {
      props.onCtrlEnter?.();
    }
  }

  return <TextArea
    style={{
      ...props.style,
      lineHeight: `${16}px`,
      height: "100%",
    }}
    placeholder={props.placeholder}
    rows={props.rows || 6}
    ref={textAreaRef.refSetter}
    value={props.value}
    onChange={onChange}
    maxLength={props.maxLength}
    onBlur={() => { props.onBlur?.(); }}
    onKeyDown={onKeyDown}
    fluid="true"
    disabled={props.disabled}
  />;
};

interface DetailProps {
  children: string;
}

export const OptionalTextAreaDetails = (props: DetailProps) => {
  return <div>{replaceNewLineWithBr(props.children || "")}</div>
}

export default OptionalTextAreaInput;